import type { BuildFields } from 'ra-data-hasura';
import gql from 'graphql-tag';
import { extractFieldsFromQuery } from '../Common';
import { GET_ONE } from 'react-admin';

// Define the additional fields that we want.
const EXTEND_ONE = gql`
  {
    workflow {
      stages {
        id
        name
      }
    }
  }
`;

const projectDAO = (defaultFields: BuildFields, fetchType: string) => {
  if (GET_ONE === fetchType) {
    const relatedEntities = extractFieldsFromQuery(EXTEND_ONE);
    defaultFields.push(...relatedEntities);
  }
  return defaultFields;
};

export default projectDAO;